import { ModelFactory } from "../../ModelFactory";

export type RoleScope = "tenant" | "own"
export type AccessLevel = "none" | "viewer" | "editor" | "full_access"
export type RolePermissions = { [resource: string]: { [scope in RoleScope]: AccessLevel } }

export class Role {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly displayName: string,
    public readonly isDefault: boolean,
    public readonly permissions: RolePermissions,
    public readonly created: Date,
    public readonly updated: Date,
  ) {
  }
}

class RoleFactory extends ModelFactory<Role> {
  protected fromJson(json: any): Role {
    return new Role(
      json['id'],
      json['name'],
      json['display_name'],
      json['is_default'] ?? false,
      json['permissions'] ?? {},
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}
export const roleFactory = new RoleFactory();

export class RoleOptions {
  constructor(
    public readonly resources: string[],
    public readonly scopes: RoleScope[],
    public readonly levels: AccessLevel[],
  ) {
  }
}

class RoleOptionsFactory extends ModelFactory<RoleOptions> {
  protected fromJson(json: any): RoleOptions {
    return new RoleOptions(
      json['resources'] ?? [],
      json['scopes'] ?? [],
      json['levels'] ?? [],
    );
  }
}
export const roleOptionsFactory = new RoleOptionsFactory();
